<template>
  <div :class="['manager-layout', { 'fixed-list-layout': fixedList }]">
    <aside class="sidebar">
      <div class="sidebar-brand">
        <strong>启明服务管理平台</strong>
        <span>滕州启明眼科医院</span>
      </div>

      <nav class="sidebar-nav" aria-label="管理导航">
        <span class="nav-heading">工作台</span>
        <router-link to="/" exact-active-class="nav-active">
          <van-icon name="wap-home-o" aria-hidden="true" />
          <span>首页</span>
        </router-link>
        <router-link to="/wechat-followers" active-class="nav-active">
          <van-icon name="friends-o" aria-hidden="true" />
          <span>微信用户</span>
        </router-link>
        <router-link to="/patient-revisit" active-class="nav-active">
          <van-icon name="todo-list-o" aria-hidden="true" />
          <span>患者回访</span>
        </router-link>
        <router-link to="/feedback" active-class="nav-active">
          <van-icon name="comment-o" aria-hidden="true" />
          <span>患者反馈</span>
        </router-link>
        <router-link to="/departments" active-class="nav-active">
          <van-icon name="label-o" aria-hidden="true" />
          <span>科室维护</span>
        </router-link>
        <router-link to="/appointment-slots" active-class="nav-active">
          <van-icon name="calendar-o" aria-hidden="true" />
          <span>号源维护</span>
        </router-link>
        <router-link to="/appointments" active-class="nav-active">
          <van-icon name="records" aria-hidden="true" />
          <span>预约记录</span>
        </router-link>
      </nav>

      <div class="sidebar-footer">启明眼科</div>
    </aside>

    <div class="workspace">
      <header class="workspace-header">
        <span class="page-name">{{ $route.meta.title }}</span>
        <div class="account">
          <span v-if="employee" class="account-name">{{ employee.displayName || employee.username }}</span>
          <button v-if="employee" type="button" class="account-action" @click="handleLogout">退出登录</button>
          <router-link v-else class="account-action" to="/login">登录</router-link>
        </div>
      </header>
      <slot />
    </div>
  </div>
</template>

<script>
import { isNavigationFailure } from 'vue-router'
import { Icon } from 'vant'
import { state, logout } from '@/store/session'
import 'vant/lib/icon/index.css'

export default {
  name: 'ManagerLayout',
  components: { 'van-icon': Icon },
  props: { fixedList: Boolean },
  computed: {
    employee () { return state.employee }
  },
  methods: {
    async handleLogout () {
      await logout()
      if (this.$route.name === 'login') return
      try {
        await this.$router.replace({ name: 'login' })
      } catch (error) {
        if (!isNavigationFailure(error)) window.location.hash = '#/login'
      }
    }
  }
}
</script>

<style scoped>
.manager-layout { display: grid; grid-template-columns: 232px minmax(0, 1fr); min-height: 100vh; background: #f5f7f6; }
.sidebar { position: sticky; top: 0; display: flex; flex-direction: column; height: 100vh; min-height: 0; overflow-y: auto; border-right: 1px solid #dce5e2; background: #fff; }
.sidebar-brand { display: flex; flex-direction: column; gap: 5px; padding: 24px 22px 27px; border-bottom: 1px solid #edf1ef; }
.sidebar-brand strong { color: #173b46; font-size: 17px; }
.sidebar-brand span { color: #899b9a; font-size: 11px; }
.sidebar-nav { display: flex; flex-direction: column; gap: 5px; padding: 23px 12px; }
.nav-heading { padding: 0 13px 11px; color: #92a2a0; font-size: 11px; }
.sidebar-nav a { display: flex; align-items: center; gap: 12px; min-height: 44px; padding: 0 13px; border-radius: 5px; color: #50666b; font-size: 14px; text-decoration: none; }
.sidebar-nav a:hover { background: #f1f6f4; color: #176e66; }
.sidebar-nav a.nav-active { background: #e6f3ee; color: #146b62; font-weight: 600; }
.sidebar-nav .van-icon { flex: none; font-size: 19px; }
.sidebar-footer { margin-top: auto; padding: 18px 25px 23px; border-top: 1px solid #edf1ef; color: #9caaa8; font-size: 11px; }
.workspace { display: flex; flex-direction: column; min-width: 0; min-height: 100vh; }
.fixed-list-layout { height:100vh; height:100dvh; min-height:0; overflow:hidden; }
.fixed-list-layout .workspace { height:100%; min-height:0; overflow:hidden; }
.fixed-list-layout .workspace-header { flex:none; }
.fixed-list-layout ::v-deep .manager-list-page { flex:1; height:auto; min-height:0; overflow:hidden; }
.fixed-list-layout ::v-deep .manager-list-page > :not(.table-wrap) { flex-shrink:0; }
.fixed-list-layout ::v-deep .manager-list-page > .table-wrap { flex:1 1 0; min-height:0; min-width:0; overflow:hidden; }
.fixed-list-layout ::v-deep .el-table__body-wrapper { overscroll-behavior:contain; }
.fixed-list-layout ::v-deep .workspace > .app-header,
.fixed-list-layout ::v-deep .workspace > .header { flex:none; }
.workspace-header { position: sticky; top: 0; z-index: 10; display: flex; align-items: center; gap: 16px; min-height: 64px; padding: 0 32px; border-bottom: 1px solid #dce5e2; background: #fff; }
.page-name { color: #284a4d; font-size: 15px; font-weight: 600; }
.account { display: flex; align-items: center; gap: 16px; min-width: 0; margin-left: auto; font-size: 13px; }
.account-name { max-width: 180px; overflow: hidden; color: #61777a; text-overflow: ellipsis; white-space: nowrap; }
.account-action { padding: 6px 0; border: 0; color: #237d72; background: transparent; cursor: pointer; font: inherit; text-decoration: none; white-space: nowrap; }
.account-action:hover { color: #155d55; }
@media (max-width: 900px) {
  .manager-layout { display: block; }
  .sidebar, .workspace-header { display: none; }
}
</style>
